'use client';

import { create } from 'zustand';
import type { ShowPopupOptions } from '../bootstrap/tmaActions';

export interface ConfirmDialogRequest {
  id: number;
  options: ShowPopupOptions;
  resolve: (buttonId: string | null) => void;
}

interface ConfirmDialogState {
  queue: ConfirmDialogRequest[];
  hosts: symbol[];
  enqueue: (request: ConfirmDialogRequest) => void;
  drop: (id: number) => void;
  addHost: (token: symbol) => void;
  removeHost: (token: symbol) => void;
}

let nextRequestId = 1;

export const useConfirmDialogStore = create<ConfirmDialogState>((set) => ({
  queue: [],
  hosts: [],
  enqueue: (request) => set((s) => ({ queue: [...s.queue, request] })),
  drop: (id) => set((s) => ({ queue: s.queue.filter((r) => r.id !== id) })),
  addHost: (token) => set((s) => ({ hosts: [...s.hosts, token] })),
  removeHost: (token) => set((s) => ({ hosts: s.hosts.filter((t) => t !== token) })),
}));

export function hasConfirmDialogHost(): boolean {
  return useConfirmDialogStore.getState().hosts.length > 0;
}

export function openConfirmDialog(options: ShowPopupOptions): Promise<string | null> {
  return new Promise((resolve) => {
    useConfirmDialogStore.getState().enqueue({ id: nextRequestId++, options, resolve });
  });
}
